import { Link } from "react-router-dom";

export default function Why() {
  return (
    <article className="prose-page">
      <h1>Why DreamHomeJourney</h1>
      <p className="lead">
        This origin is the front porch of REChecklist: user manuals, support, vendors, events, and
        community. It does not duplicate the desk. It explains the companion.
      </p>
      <section>
        <h2>A porch, not a second product</h2>
        <p>
          Role manuals live here behind a sign-in so the working screens on REChecklist can stay a
          framed workspace. Buyer and seller journeys never mix — here or there.
        </p>
      </section>
      <section>
        <h2>Warm enough to read, precise enough to use</h2>
        <p>
          HomeSpec precision with DreamHome warmth. We would rather fill a page with a complete
          explanation than leave an empty grid of cards.
        </p>
      </section>
      <section>
        <h2>What this site is not</h2>
        <p>
          Not a listing marketplace, not a search engine, and not a California DRE certification
          board. License numbers you record on the desk are yours; we do not grant or verify them.
        </p>
      </section>
      <p>
        <Link to="/why-rechecklist">Why REChecklist</Link>
        {" · "}
        <Link to="/manuals">User manuals</Link>
      </p>
    </article>
  );
}
